export const getMailBody = (subject: string, email: string, message: string) => {
    return `mailto:${email}?subject=${subject}&body=${message}`;
};
